import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>(() => ({
  messageContainer: {
    padding: "20px",
    backgroundColor: "#ededed",
    borderRadius: "10px",
    marginBottom: "20px",
    color: "#4a4c58",
    textAlign: "left",
  },
  messageTitle: {
    display: "flex",
    fontSize: "16px",
  },
  messageIcon: {
    marginRight: "20px",
    width: "20px",
    height: "20px",
  },
  messageContent: {
    fontSize: "14px",
    color: "#484a56b3",
  },
}));
